'use client';

import { useEffect } from 'react';

export default function ClientScrollPositionSetter() {
  useEffect(() => {
    const htmlElement = document.documentElement;
    htmlElement.style.setProperty('--scroll', 1);

    function setScrollVar() {
      const screenHeightScrolled = htmlElement.scrollTop;
      htmlElement.style.setProperty('--scroll', screenHeightScrolled);
    }
    setScrollVar();

    window.addEventListener('scroll', setScrollVar);
    window.addEventListener('resize', setScrollVar);
  }, []);
}
